"use client"

import { Box, Center, Stack } from "@mantine/core"
import { AppTitle, Footer, ShellLayout } from "@/components"
import { Guard } from "@/components/utils"
import { anonymous } from "@/utils"

export default function NotFound() {
  return (
    <Guard permissions={anonymous}>
      <ShellLayout>
        <Center h="90vh">
          <Stack gap="xl" align="center">
            <Box component="span" fz={100} fw={700} ta="center">
              4🤔4
            </Box>
            <AppTitle fz={32}>Unfortunatelly, this page does not exist.</AppTitle>
            <Footer />
          </Stack>
        </Center>
      </ShellLayout>
    </Guard>
  )
}
